module.exports = __webpack_public_path__ + "static/media/1.452ee1f6.png";